"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeConversion = void 0;
var i18next_1 = __importDefault(require("i18next"));
function timeConversion(duration) {
    var maxPortions = 3;
    var portions = [];
    if (portions.length < maxPortions) {
        var msInDay = 1000 * 60 * 60 * 24;
        var days = Math.trunc(duration / msInDay);
        if (portions.length != 0 || days > 0) {
            portions.push(days + i18next_1.default.t("days_abbreviated"));
            duration = duration - (days * msInDay);
        }
    }
    if (portions.length < maxPortions) {
        var msInHour = 1000 * 60 * 60;
        var hours = Math.trunc(duration / msInHour);
        if (portions.length != 0 || hours > 0) {
            portions.push(hours + i18next_1.default.t("hours_abbreviated"));
            duration = duration - (hours * msInHour);
        }
    }
    if (portions.length < maxPortions) {
        var msInMinute = 1000 * 60;
        var minutes = Math.trunc(duration / msInMinute);
        if (portions.length != 0 || minutes > 0) {
            portions.push(minutes + i18next_1.default.t("minutes_abbreviated"));
            duration = duration - (minutes * msInMinute);
        }
    }
    if (portions.length < maxPortions) {
        var seconds = Math.trunc(duration / 1000);
        portions.push(seconds + i18next_1.default.t("seconds_abbreviated"));
    }
    return portions.join(" ");
}
exports.timeConversion = timeConversion;
